// ja translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const ja = {
    // Common
    "common.loading": "読み込み中...",
    "common.save": "保存",
    "common.cancel": "キャンセル",
    "common.delete": "削除",
    "common.edit": "編集",
    "common.submit": "送信",
    "common.logout": "ログアウト",
    "common.login": "ログイン",
    "common.register": "登録",
    
    // Auth
    "auth.welcome": "ようこそ",
    "auth.signIn": "アカウントにサインイン",
    "auth.email": "メールアドレス",
    "auth.password": "パスワード",
    "auth.loginButton": "サインイン",
    
    // Navigation
    "nav.dashboard": "ダッシュボード",
    "nav.releases": "リリース",
    "nav.payouts": "支払い",
    "nav.support": "サポート",
    "nav.referrals": "紹介",
    "nav.profile": "プロフィール",
    
    // Dashboard
    "dashboard.welcome": "ようこそ",
    "dashboard.subtitle": "音楽を管理し、リリースを追跡し、収益を確認します。",
    "dashboard.totalReleases": "総リリース数",
    "dashboard.totalTracks": "総トラック数",
    "dashboard.balance": "現在の残高",
    "dashboard.withdrawable": "引き出し可能",
    "dashboard.recentReleases": "最近のリリース",
    "dashboard.newRelease": "新規リリース",
    "dashboard.requestPayout": "支払いリクエスト",
    
    // Analytics
    "analytics.title": "統計",
    "analytics.subtitle": "リリースのパフォーマンスを追跡",
    "analytics.totalStreams": "総再生回数",
    "analytics.listeners": "リスナー",
    "analytics.estimatedEarnings": "推定収益",
    "analytics.monthlyGrowth": "月間成長率",
    "analytics.streamsChart": "再生チャート",
    "analytics.platformDistribution": "プラットフォーム分布",
    "analytics.topTracks": "人気トラック",
    "analytics.trackName": "トラック名",
    "analytics.streams": "再生",
    "analytics.comingSoonTitle": "近日公開",
    "analytics.comingSoonDesc": "詳細な分析とインサイトは近日公開予定です。artist.tools連携により、すべてのプラットフォームデータを一箇所で追跡できるようになります。",
    "common.comingSoon": "近日公開",
    
    // Payouts
    "payouts.title": "収益を管理",
    "payouts.subtitle": "音楽収益を簡単に引き出せます。最低$50から支払いをリクエストできます。",
    "payouts.fastPayment": "迅速な支払い",
    "payouts.secureTransfer": "安全な送金",
    "payouts.totalBalance": "総残高",
    "payouts.withdrawableBalance": "引き出し可能額",
    "payouts.requestPayout": "支払いリクエスト",
    "payouts.payoutHistory": "支払い履歴",
    "payouts.noPayouts": "支払いリクエストはまだありません",
    "payouts.noPaymentMethod": "支払い方法なし",
    "payouts.addMethodDesc": "収益を引き出すには支払い方法を追加してください。",
    "payouts.addMethod": "支払い方法を追加",
    "payouts.changeMethodVerification": "現在の支払い方法を変更するにはメール認証が必要です",
    "payouts.availableBalance": "利用可能残高",
    "payouts.pendingBalance": "保留中残高",
    "payouts.withdrawalHistory": "引き出し履歴",
    "payouts.requestWithdrawal": "引き出しリクエスト",
    "payouts.minWithdrawal": "最低引き出し額: $50",
    "payouts.manageEarnings": "収益を管理",
    "payouts.createRequest": "支払いリクエストを作成",
    "payouts.amount": "金額",
    "payouts.accountHolder": "口座名義人",
    "payouts.bankName": "銀行名",
    "payouts.minAmount": "最低引き出し額は$50です",
    "payouts.insufficientBalance": "残高不足",
    "payouts.fillRequired": "必須項目をすべて入力してください",
    "payouts.requestCreated": "支払いリクエストが作成されました",
    "payouts.requestFailed": "リクエストに失敗しました",
    "payouts.minNotMet": "最低額未満",
    "payouts.minNotMetMsg": "支払いをリクエストするには、少なくとも$50の引き出し可能残高が必要です。",
    "payouts.statusRequested": "リクエスト済み",
    "payouts.statusPaid": "支払い済み",
    "payouts.paymentMethod": "支払い方法",
    "payouts.bankTransfer": "銀行振込",
    "payouts.paypalEmail": "PayPalメール",
    "payouts.paypalNote": "PayPalアカウントに関連付けられたメールアドレスを入力",
    "payouts.fillPaypalRequired": "PayPalメールと口座名義人を入力してください",
    "payouts.selectCountry": "国を選択",
    "payouts.tabProfile": "支払いプロファイル",
    "payouts.tabMethod": "支払い方法",
    "payouts.tabRequests": "引き出しリクエスト",
    "payouts.requirements": "引き出し要件",
    "payouts.completeProfile": "支払いプロファイルを完成させてください（身元と住所）",
    "payouts.addPaymentMethod": "支払い方法を追加してください（銀行またはPayPal）",
    "payouts.verifyPaymentMethod": "支払い方法を確認してください",
    "payouts.profileComplete": "完了",
    "payouts.savedProfile": "保存されたプロファイル情報",
    "payouts.fullName": "氏名",
    "payouts.phoneNumber": "電話番号",
    "payouts.location": "場所",
    "payouts.profileType": "プロファイルタイプ",
    "payouts.individual": "個人",
    "payouts.business": "企業/会社",
    "payouts.edit": "編集",
    
    // Statuses
    "status.draft": "下書き",
    "status.submitted": "提出済み",
    "status.approved": "承認済み",
    "status.rejected": "却下",
    "status.live": "公開中",
    
    // Validation
    "validation.audioRequired": "オーディオファイルは必須です",
    "validation.audioFormatWav": "オーディオファイルはWAVまたはFLAC形式である必要があります",
    "validation.titleRequired": "タイトルは必須です",
    "validation.titleLanguageRequired": "タイトルの言語は必須です",
    "validation.primaryArtistRequired": "少なくとも1人のメインアーティストが必要です",
    "validation.primaryGenreRequired": "メインジャンルの選択は必須です",
    "validation.explicitRequired": "コンテンツタイプの選択は必須です",
    "validation.coverRequired": "カバー画像は必須です",
    "validation.songwriterRequired": "少なくとも1人のソングライターが必要です",
    "validation.contributorRequired": "少なくとも1人の貢献者が必要です",
    "validation.productionTeamRequired": "少なくとも1人の制作チームメンバーが必要です",
    "validation.platformRequired": "少なくとも1つのプラットフォームを選択する必要があります",
    "validation.releaseDateRequired": "リリース日は必須です",
    "validation.trackCountRequired": "EP/アルバムには最低2曲が必要です",
    "releases.track": "トラック",
    
    // Toast Messages
    "toast.saveSuccess": "保存しました",
    "toast.saveFailed": "保存に失敗しました",
    "toast.deleteSuccess": "削除しました",
    "toast.uploadSuccess": "アップロードしました",
    "toast.submitSuccess": "送信しました",
    "toast.loginSuccess": "ログインしました",
    "toast.copySuccess": "クリップボードにコピーしました",
    "toast.errorOccurred": "エラーが発生しました",
    "toast.pleaseFixErrors": "このセクションのエラーを修正してください",
    
    // Spotify
    "spotify.comingSoon": "近日公開",
};

export default ja;
